import type { InvoiceFilterDto } from "Infrastructure/Api/Api";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { selectedVerticalsAtom } from "Shared/Atoms/verticalAtom";
import { DEFAULT_VERTICALS } from "Shared/consts";
import { useAtom } from "jotai";
import { useMemo } from "react";
import { useSearchParams } from "react-router";

export const useInvoiceFilters = (): InvoiceFilterDto => {
	const { market } = useMarket();
	const [query] = useSearchParams();
	const [selectedVerticals] = useAtom(selectedVerticalsAtom);

	return useMemo(
		() => ({
			marketId: query.get("marketId")
				? Number(query.get("marketId"))
				: (market?.id ?? undefined),
			verticals:
				selectedVerticals.length > 0
					? selectedVerticals.join(",")
					: DEFAULT_VERTICALS,
		}),
		[query, market?.id, selectedVerticals],
	);
};
